
import React, { useState } from 'react';
import DatePickerModal from './DatePickerModal';
import TimeSlotModal from './TimeSlotModal';

const BookingModal = ({ show, handleClose, doctor }) => {
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [showTimeSlot, setShowTimeSlot] = useState(false);
  const [selectedBookingData, setSelectedBookingData] = useState(null);

  // Reset everything when modal closes
  const handleCloseAll = () => {
    setShowDatePicker(false);
    setShowTimeSlot(false);
    setSelectedBookingData(null);
    handleClose();
  };

  // When date is selected in DatePickerModal
  const handleDateSelect = (bookingData) => {
    console.log("Date selected:", bookingData);
    setSelectedBookingData(bookingData);
    setShowDatePicker(false);
    setShowTimeSlot(true);
  };

  // Go back from TimeSlot to DatePicker
  const handleBackToDatePicker = () => {
    console.log("Going back to date picker");
    setShowTimeSlot(false);
    setTimeout(() => {
      setShowDatePicker(true);
    }, 300);
  };

  // Complete booking flow
  const handleBookingComplete = () => {
    console.log("Booking completed");
    handleCloseAll();
  };

  // Start the booking flow when modal opens
  React.useEffect(() => {
    if (show && !showDatePicker && !showTimeSlot) {
      setShowDatePicker(true);
    }
  }, [show]);

  return (
    <>
      {/* Date Picker Modal - First Step */}
      {showDatePicker && (
        <DatePickerModal
          show={showDatePicker}
          handleClose={handleCloseAll}
          doctor={doctor}
          onDateSelect={handleDateSelect}
        />
      )}

      {/* Time Slot Modal - Second Step */}
      {showTimeSlot && (
        <TimeSlotModal
          show={showTimeSlot}
          handleClose={handleCloseAll}
          bookingData={selectedBookingData}
          onBack={handleBackToDatePicker}
          onBookingComplete={handleBookingComplete}
        />
      )}
    </>
  );
};

export default BookingModal;